<template>
  <footer>
    <div class="top-footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-2 col-md-3">
            <div class="footer-logo">
              <a href="/">
                <img src="amej-pay.png" alt="Amej Pay Logo" />
              </a>
            </div>
          </div>
          <div class="col-lg-7 col-md-9 col-sm-12">
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-4">
                <h6>Company</h6>
                <ul>
                  <li>
                    <router-link :to="{ name: 'AboutUsPage' }"
                      >About</router-link
                    >
                  </li>
                  <li>
                    <router-link :to="{ name: 'contactpagenew' }"
                      >Contact</router-link
                    >
                  </li>
                  <li>
                    <a href="https://blog.amejpay.com/" target="_blank">Blog</a>
                  </li>
                  <li>
                    <router-link :to="{ name: 'Merchant' }">Apply for Merchant</router-link>
                  </li>
                </ul>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-4">
                <h6>Policy</h6>
                <ul>
                  <li>
                    <router-link :to="{ name: 'pricacyPolicy' }"
                      >Privacy Policy</router-link
                    >
                  </li>
                  <li>
                    <router-link :to="{ name: 'termAndCondition' }"
                      >Terms & Conditions</router-link
                    >
                  </li>
                  <li>
                    <router-link :to="{ name: 'accountdelete' }"
                      >Account Deletion</router-link
                    >
                  </li>
                </ul>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-4">
                <h6>Help</h6>
                <ul>
                  <li>
                    <router-link :to="{ name: 'customerCare' }"
                      >Customer Care</router-link
                    >
                  </li>
                  <li>
                    <router-link :to="{ name: 'faqNew' }">FAQs</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="d-lg-none col-md-3"></div>

          <div class="col-lg-3 col-md-9">
            <div class="row">
              <div class="col-lg-12 col-md-6 col-sm-6">
                <h6>Download</h6>
                <div class="row footer-download-icons">
                  <div class="col-6">
                    <a
                      href="https://apps.apple.com/app/apay/id1566612928"
                      target="_blank"
                      ><img
                        src="../../assets/app_store.png"
                        alt=""
                        class="download-icons"
                    /></a>
                  </div>
                  <div class="col-6">
                    <a
                      href="https://play.google.com/store/apps/details?id=com.amejpay.singapore&hl=en&gl=US"
                      target="_blank"
                      ><img
                        src="../../assets/google_play.png"
                        alt=""
                        class="download-icons"
                    /></a>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 col-md-6 col-sm-6">
                <h6>Connect With Us</h6>
                <div class="row footer-social-media">
                  <a href="https://www.facebook.com/amej.pay/" target="_blank"
                    ><i class="fa fa-facebook"></i
                  ></a>
                  <a
                    href="https://www.linkedin.com/company/amejpay"
                    target="_blank"
                    ><i class="fa fa-linkedin"></i
                  ></a>
                  <a
                    href="https://www.youtube.com/channel/UCP_6007tMa2Y0z0njRclE-w"
                    target="_blank"
                    ><i class="fa fa-youtube"></i
                  ></a>
                  <a href="https://twitter.com/amejpay" target="_blank"
                    ><i class="fa fa-twitter"></i
                  ></a>
                  <a href="https://www.instagram.com/amejpay/" target="_blank"
                    ><i class="fa fa-instagram"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-footer">
      <div class="container text-center">
        <p>&copy; {{ currentYear }} Amej Pay. All Rights Reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script type="text/javascript">
// import $ from "jquery";
export default {
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
  mounted() {
    // Add Custom JS
    let slimMinJS = document.createElement("script");
    slimMinJS.setAttribute(
      "src",
      "https://code.jquery.com/jquery-3.3.1.slim.min.js"
    );
    document.head.appendChild(slimMinJS);

    let properMinJS = document.createElement("script");
    properMinJS.setAttribute(
      "src",
      "https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.7/umd/popper.min.js"
    );
    document.head.appendChild(properMinJS);

    // let owlCarasoulJs = document.createElement("script");
    // owlCarasoulJs.setAttribute(
    //   "src",
    //   "https://cdnjs.cloudflare.com/ajax/libs/owl-carousel/1.3.3/owl.carousel.min.js"
    // );
    // document.head.appendChild(owlCarasoulJs);
  },
};
</script>
<style type="text/css" scoped>
footer {
  background: #000000 !important;
}
</style>